import { AntdTable, OptionType, Progress, Spinner, Text } from '@agro-club/agroclub-shared'
import { addMonths, format, lastDayOfMonth } from 'date-fns'
import { SERVER_DATE_FORMAT } from 'modules/constants'
import { useGetOfferPrices } from 'modules/domain/bid/useGetOfferPrices'
import { refetchFunc } from 'modules/domain/common/hooks'
import { Address } from 'modules/domain/types'
import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import ASelect from 'views/components/Analytics/ASelect'
import { Card } from 'views/components/Card/Card'
import { HrWithHeader } from 'views/components/Hr/Hr'
import { ADateRangePicker } from 'views/components/TableFilters/DateRangePicker/ADateRangePicker'
import { useBestColumns } from './useBestColumns'
import { useClosestColumns } from './useClosestColumns'

type Props = {
  addressesRefetch: refetchFunc
  addresses: Address[]
  progress: Progress
}

const PeriodFilterWrapper = styled.div`
  display: flex;
  column-gap: 12px;
  align-items: center;
`
const WrapperTable = styled.div`
  .ant-table-cell {
    padding: 12px 6px !important;
  }
`

export const Offers: FC<Props> = ({ addresses, progress }) => {
  const { t } = useTranslation('bid')
  const [currAddress, setCurrAddress] = useState<Address>()
  const defaultRangePickerValue = {
    start_date: '',
    end_date: format(lastDayOfMonth(addMonths(new Date(), 1)), SERVER_DATE_FORMAT),
  }
  const [rangeDate, setRangeDate] = useState<any>(defaultRangePickerValue)
  const [addrOptions, setAddrOptions] = useState<OptionType[]>([])
  const { offersProgress, offers } = useGetOfferPrices(currAddress, rangeDate)

  const closestColumns = useClosestColumns()
  const bestColumns = useBestColumns()

  useEffect(() => {
    setAddrOptions(addresses.map((a) => ({ label: a.address, value: String(a.id), dto: a })))
    setCurrAddress(addresses[0])
  }, [addresses])

  if (progress == Progress.WORK) return <Spinner />
  if (!addresses.length) return null

  return (
    <Card.GapableContent>
      <PeriodFilterWrapper>
        <Text>{t('form.deliveryPeriod')}</Text>
        <ADateRangePicker
          value={[rangeDate.start_date, rangeDate.end_date]}
          onChange={(value) => setRangeDate({ start_date: value.startDate, end_date: value.endDate })}
          id="dateFilter"
          allowEmpty={[true, true]}
          place="ShowPrice"
        />
      </PeriodFilterWrapper>
      <ASelect
        onChange={(addr) => {
          setCurrAddress(addresses.find((a) => a.id == addr))
        }}
        value={String(currAddress?.id)}
        options={addrOptions}
        showSearch={false}
        fullWidth
        allowClear={false}
        id="addressFilter"
        place="ShowPrice"
      />
      <WrapperTable>
        <HrWithHeader typography="accentMedium" text={t('usShortBid.ourOffers')} marginBottom="4px" forForm={false} />
        <AntdTable
          pagination={false}
          data={offers.best}
          columns={bestColumns}
          rowHoverGray
          outerBordered
          progress={offersProgress}
        />
      </WrapperTable>
      <WrapperTable>
        <HrWithHeader
          typography="accentMedium"
          text={t('usShortBid.closestBuyer')}
          marginBottom="4px"
          forForm={false}
        />
        <AntdTable
          pagination={false}
          data={offers.closest}
          columns={closestColumns}
          rowHoverGray
          outerBordered
          progress={offersProgress}
        />
      </WrapperTable>
    </Card.GapableContent>
  )
}
